
<script lang="ts">
	import Router from "./Router.svelte";
</script>

<main class="h-full" >
	<Router></Router>
</main>


<style global lang="postcss">
	@tailwind base;
	@tailwind components;
	@tailwind utilities;


	@layer base {
		h1 {
			@apply text-3xl;
		}
		h2 {
			@apply text-2xl;
		}
		h3 {
			@apply text-xl;
		}
		input {
			@apply shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight;
		}
		label {
			@apply block text-gray-700 text-sm font-bold mb-2;
		}
		select {
			@apply block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500;
		}
	}
</style>